/** @fileoverview Skeleton shown while the student tracker is loading. */

import { Box, Skeleton, Stack } from '@mantine/core'

const SUMMARY_HEIGHT = 50
const TABLE_HEIGHT = 260

export function StudentTrackerLoadingState() {
  return (
    <Box py='md'>
      <Stack spacing='md'>
        <Skeleton height={SUMMARY_HEIGHT} radius='md' />
        <Skeleton height={TABLE_HEIGHT} radius='md' />
      </Stack>
    </Box>
  )
}
